import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./sub-service.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "../service/service.graphql";
import * as fromSubServiceGraphql from "./sub-service.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class SubServiceEffects {



  createSubService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createSubService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTITUTION_SERVICE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertSubService({ subService: result?.data }));
              this.notificationSubService.successMessage('Created Successfully ');
            } else {
              this.notificationSubService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateSubService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editSubService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION_SERVICE,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertSubService({ subService: result?.data }));
              this.notificationSubService.successMessage('Updated Successfully ');
            } else {
              this.notificationSubService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteSubService$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeSubService),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTITUTION_SERVICE,
        variables: {
          serviceUniqueId: action?.serviceUniqueId,
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteSubService({ id: action.id }));
              this.notificationSubService.successMessage('Deleted Successfully');
            } else {
              this.notificationSubService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllSubServices$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllSubService),
    switchMap((action) => {
      return this.apollo.query({
        query: fromSubServiceGraphql.GET_INSTITUTION_SUB_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while fetching sub services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadSubServices({ subServices: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationSubService: NotificationService,
    private responseCodesSubService: ResponseCodeService
  ) {}
}
